import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';

// ============================================
// IMPORT YOUR 13 WATER SUPPLY IMAGES HERE ⬇️
// ============================================
import water1 from '../assets/images/water1.jpg';
import water2 from '../assets/images/water2.jpg';
import water3 from '../assets/images/water3.jpg';
import water4 from '../assets/images/water4.jpg';
import water5 from '../assets/images/water5.jpg';
import water6 from '../assets/images/water6.jpg';
import water7 from '../assets/images/water7.jpg';
import water8 from '../assets/images/water8.jpg';
import water9 from '../assets/images/water9.jpg';
import water10 from '../assets/images/water10.jpg';
import water11 from '../assets/images/water11.jpg';
import water12 from '../assets/images/water12.jpg';
import water13 from '../assets/images/water13.jpg';

import '../styles/Pages.css';

const WaterSupplyWorks = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // All 13 images array
  const images = [
    water1, water2, water3, water4, water5,
    water6, water7, water8, water9, water10,
    water11, water12, water13
  ];

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Water Supply Works</h1>
            <p>Rural Water Supply & Sanitation Solutions</p>
          </div>
        </div>
      </section>

      {/* IMAGES SECTION - 13 IMAGES IN 3-COLUMN GRID */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          
          {/* HEADING */}
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '50px', 
            textAlign: 'center' 
          }}>
            Water Supply Projects
          </h2>

          {/* IMAGES GRID - 3 COLUMNS (5 ROWS) */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '30px',
            marginTop: '40px'
          }}>
            {images.map((img, index) => (
              <div 
                key={index}
                style={{ 
                  overflow: 'hidden', 
                  borderRadius: '8px', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.12)', 
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  aspectRatio: '1'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
                }}
              >
                <img 
                  src={img} 
                  alt={`Water Supply ${index + 1}`}
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover', 
                    display: 'block',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEXT SECTION AT BOTTOM */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '30px', 
            textAlign: 'center' 
          }}>
            Mission Bhagiratha Projects
          </h2>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8', 
            marginBottom: '20px',
            textAlign: 'justify'
          }}>
            We have successfully completed Water Supply for LMD-Karimnagar & Mankondur-Husnabad-Huzurabad under Mission Bhagiratha (Rural Water Supply & Sanitation), Telangana and O&M activities are in progress by Max Infra.
          </p>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8',
            textAlign: 'justify'
          }}>
            Our commitment to providing clean and reliable water supply to rural communities reflects our dedication to nation-building. With our expertise in water supply infrastructure and proven track record in project execution, Max Infra continues to contribute to Mission Bhagiratha's vision of bringing safe drinking water to every household in Telangana.
          </p>
        </div>
      </section>

      <Footer />

      {/* RESPONSIVE DESIGN */}
      <style>{`
        @media (max-width: 1024px) {
          .water-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 25px !important;
          }
        }
        @media (max-width: 768px) {
          .water-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default WaterSupplyWorks;